import * as runtime from '@/api/runtime'
import {
  BatchForcedReturnRequest,
  BatchForcedReturnRequestToJSON,
  BatchStatisticsPageLoadRequest,
  BatchStatisticsPageLoadRequestToJSON
} from '@/api/models/batch'
import {
  BatchForcedReturnCondition,
  BatchForcedReturnConditionFromJSON
} from '@/api/models/batch/BatchForcedReturnCondition'

/**
 * 帳票作成
 */
export class BatchForcedReturnApi extends runtime.BaseAPI {
  async return(request: BatchForcedReturnRequest): Promise<number> {
    const response = await this.requestPost(
      `/batch/return/forced_return`,
      BatchForcedReturnRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      Number(jsonValue.request_id)
    ).value()
  }

  async getInitialCondition(
    request: BatchStatisticsPageLoadRequest
  ): Promise<BatchForcedReturnCondition> {
    const response = await this.requestGet(
      `/batch/statistics/search_initial_condition`,
      BatchStatisticsPageLoadRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      BatchForcedReturnConditionFromJSON(jsonValue)
    ).value()
  }
}
